import { DecisionMakerIcon } from '@change/ds-icons';

import { Badge, Text } from '@change/ds-core-ui/next';

import type { LegislativeBody } from '../../../shared/types';
import { Location } from '../../shared/Location';
import { Member } from '../Member';
import { ViewMore } from '../ViewMore';

export const BodyContent: React.FC<{
	legislativeBody: LegislativeBody;
}> = ({ legislativeBody }) => {
	const { title, location, displayedDMs, viewMoreText, responsesText, allDMs } = legislativeBody;

	return (
		<>
			<div className="mb-6 flex">
				<div>
					<div className="bg-fill-accent-primary-weaker mr-4 flex size-16 items-center justify-center rounded-full lg:size-20">
						<DecisionMakerIcon size="large" className="text-typography-information" />
					</div>
				</div>
				<div className="w-full">
					<div className="flex flex-col gap-4 lg:flex-row lg:items-start">
						<div className="w-fit flex-wrap gap-[6px] lg:flex">
							<div>
								<Text variant="heading" size="small">
									{title}
								</Text>
								<Text variant="heading" size="small" className="hidden lg:inline">
									,
								</Text>
							</div>

							<Text variant="heading" size="small" fontWeight="light">
								{allDMs.length} Members
							</Text>
						</div>

						<div className="min-w-32 lg:ml-auto">
							{responsesText && (
								<Badge
									label={responsesText}
									variant="neutral"
									className="bg-fill-success-weaker border-stroke-success-weak text-typography-success mb-2 w-fit border-[1px] font-normal lg:ml-auto"
								/>
							)}
						</div>
					</div>

					{location && <Location location={location} />}
				</div>
			</div>

			<div className="mx-4 lg:mx-12">
				{displayedDMs.map((dm) => (
					<div className="mb-4 ml-5 lg:ml-12" key={dm.id}>
						<Member {...dm} />
					</div>
				))}
				{viewMoreText && <ViewMore legislativeBody={legislativeBody} />}
			</div>
		</>
	);
};
